import { viewportCategoryToNumericColumnCount } from "../../state/modules/layout/columnCount";

const getTilePositionFromRowPosition = ({ viewportCategory, rowPosition }) => {
  const columnCount = viewportCategoryToNumericColumnCount(viewportCategory);

  return columnCount * (rowPosition - 1);
};

export default getTilePositionFromRowPosition;
